/**
 * Inverse of an ISO-week lookup: given a `(isoYear, isoWeek)` pair and a
 * `weekStartIndex` day-offset from the ISO Monday (0 = Mon, 6 = Sun), returns
 * the local-time `Date` at midnight on the resulting week-start day.
 *
 * Anchors on Jan 4, which ISO-8601 guarantees is in week 1 of `isoYear`.
 */
export function weekStartDate(isoYear: number, isoWeek: number, weekStartIndex: number): Date {
  const jan4 = new Date(isoYear, 0, 4);
  const jan4Dow = (jan4.getDay() + 6) % 7;
  const week1Monday = new Date(jan4.getFullYear(), jan4.getMonth(), jan4.getDate() - jan4Dow);
  return new Date(
    week1Monday.getFullYear(),
    week1Monday.getMonth(),
    week1Monday.getDate() + (isoWeek - 1) * 7 + weekStartIndex
  );
}
